/** The chart frame's chrome. */
export default {
  noChartData: "No chart data",
  noDataYet: "No data yet",
  noValuesYet: "No {field} values yet",
  fillsAfterFirstRun: "fills after the first run",
  fillsAfter: "fills after {when}",
  chart: "Chart",
  trend: "{title} trend",
  barTrend: "{title} bar trend",
  pointValue: "{label}: {value}",
  lineTrend: "{title} line trend",
  fromTable: "From {title}",
  period: "Period",
  allTime: "All time",
  last7Days: "Last 7 days",
  last30Days: "Last 30 days",
  last90Days: "Last 90 days",
  customPeriod: "Custom",
  periodStart: "Start date",
  periodEnd: "End date",
  noDataInPeriod: "No data in this period",
  periodFailed: "Couldn't load this period",
} as const;
